import axios from 'axios';
import * as types from '../constants/ActionTypes';

function requestICFGuides() {
  return {
    type: types.REQUEST_ICF_GUIDES,
  };
}

function receiveIcfGuides(responseData) {
  return {
    type: types.RECEIVE_ICF_GUIDES_RESPONSE,
    payload: responseData,
  };
}

function receiveIcfGuidesError() {
  return {
    type: types.RECEIVE_ICF_GUIDES_ERROR,
  };
}

export default () => (dispatch) => {
  dispatch(requestICFGuides());
  return axios
    .get('/smarthelp/get-all-icfs')
    .then((response) => {
      dispatch(receiveIcfGuides(response.data));
    })
    .catch(() => {
      dispatch(receiveIcfGuidesError());
    });
};
